export const runningFrontendCommit = import.meta.env?.VITE_PINNGRO_BUILD_COMMIT || 'unknown';

const commitPattern = /^[0-9a-f]{40}$/;

export const isLocalNotificationPath = (path, origin = globalThis.location?.origin || 'https://pinngro.test') => {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')
    || path.includes('\\') || [...path].some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)) return false;
  try {
    return new URL(path, origin).origin === origin;
  } catch {
    return false;
  }
};

// Unknown evidence takes the document-navigation path. Only an exact release
// match permits an in-memory route transition.
export const currentFrontendMatches = async (fetchVersion = fetch, runningCommit = runningFrontendCommit) => {
  if (import.meta.env?.DEV) return true;
  if (!commitPattern.test(runningCommit)) return false;
  try {
    // The current nginx/Caddy path has no response cache. Use a unique URL as
    // well as no-store so a compliant intermediary cannot reuse an old marker.
    const nonce = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
    const response = await fetchVersion(`/frontend-version.json?check=${nonce}`, {
      cache: 'no-store', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
      signal: AbortSignal.timeout(3000),
    });
    if (!response.ok || !response.headers.get('content-type')?.includes('application/json')) return false;
    const installedCommit = (await response.json())?.commit;
    return commitPattern.test(installedCommit) && installedCommit === runningCommit;
  } catch {
    return false;
  }
};

export const hasActiveCustomerAction = (root = document) => Boolean(
  root.querySelector('[aria-busy="true"], [data-submitting="true"]'),
);

export const hasInProgressCustomerInput = (root = document, editedFields = new WeakSet()) => Boolean(
  root.querySelector('[role="alertdialog"], [role="dialog"]:not([aria-label="Notifications"])')
  || [...root.querySelectorAll('input, textarea, select, [contenteditable="true"]')]
    .some((field) => editedFields.has(field) && !field.disabled && field.type !== 'hidden'),
);
